import React from "react";
import TextField from "../../../../components/FormComponents/TextField";
import TextArea from "../../../../components/FormComponents/TextArea";
import { Form } from "semantic-ui-react";
import { useIntl } from "react-intl";
import { PatternDifficulty } from "../../../../types/siteTypes";

const DIFFICULTY_OPTIONS: PatternDifficulty[] = ["easy", "medium", "hard"];

const DescriptionFields = ({
  patternData: { name, description, descriptionLong, difficulty = "medium" },
  onChange,
}: any) => {
  const intl = useIntl();

  return (
    <React.Fragment>
      <TextField
        placeholder="Product name"
        name="name"
        value={name}
        onChange={onChange}
        // error={errors.title}
        info="Product name"
      />
      <TextArea
        placeholder="Product short description"
        name="description"
        value={description}
        onChange={onChange}
        // error={errors.description}
        info="Briefly describe your pattern in couple of sentences."
        rows={3}
      />
      <TextArea
        placeholder="Product long description"
        name="descriptionLong"
        value={descriptionLong}
        onChange={onChange}
        // error={errors.description}
        info="Describe your product nicely so everyone will want to buy it"
        rows={7}
      />
      <Form.Field>
        <label>
          {intl.formatMessage({
            id: "pattern.difficulty.label",
            defaultMessage: "Difficulty level",
          })}
        </label>
        <select name="difficulty" value={difficulty} onChange={onChange}>
          {DIFFICULTY_OPTIONS.map((option) => (
            <option key={option} value={option}>
              {intl.formatMessage({
                id: `pattern.difficulty.${option}`,
                defaultMessage: option,
              })}
            </option>
          ))}
        </select>
      </Form.Field>
    </React.Fragment>
  );
};

export default DescriptionFields;
